/**
 * Cart Rewards BFE
 * Dual-threshold progress bar: gratis verzending + gratis cadeau
 * Luistert op theme:cart:change events van Pipeline theme
 */
(function () {
  'use strict';

  /* Elementen worden dynamisch opgehaald (DOM kan vervangen worden bij cart reload) */
  var container, textEl, fillEl, milestoneShipping, milestoneGift;
  var rewardShipping, rewardGift, giftGrid, giftTrigger, giftBody;
  var shippingLimitDisplay, giftLimitDisplay;
  var excludedProductType = '';

  var shippingLimit, giftLimit, giftEnabled, rate, texts;
  var shippingRate, giftRate;
  /* Drempels in centen, al omgerekend + afgerond — zie market-threshold-bfe.js */
  var shippingThresholdCents, giftThresholdCents;
  var isProcessing = false;
  var accordionOpen = false;
  var initialized = false;

  /**
   * (Her-)initialiseer DOM referenties en configuratie
   * Wordt aangeroepen bij init én na cart reload (DOM kan vervangen zijn)
   */
  function initElements() {
    container = document.querySelector('[data-cart-rewards]');
    if (!container) return false;

    shippingLimit = Number(container.getAttribute('data-shipping-limit')) || 75;
    giftLimit = Number(container.getAttribute('data-gift-limit')) || 100;
    giftEnabled = container.getAttribute('data-gift-enabled') === 'true';
    excludedProductType = container.getAttribute('data-excluded-product-type') || '';
    rate = window.Shopify && window.Shopify.currency ? window.Shopify.currency.rate : 1;

    /* Per-market currency strategy:
     * - data-*-is-local="true"  → bedrag is al in active currency (US-tier $75 USD), skip rate
     * - data-*-is-local="false" → bedrag is in EUR-equivalent, JS converteert via Shopify.currency.rate
     */
    var shippingIsLocal = container.getAttribute('data-shipping-is-local') === 'true';
    var giftIsLocal = container.getAttribute('data-gift-is-local') === 'true';
    shippingRate = shippingIsLocal ? 1 : rate;
    giftRate = giftIsLocal ? 1 : rate;

    /* Drempels via de gedeelde helper zodat cart, banner en USP-blok exact hetzelfde
       bedrag tonen (omgerekend + naar boven afgerond). Fallback op de oude berekening
       als market-threshold-bfe.js onverhoopt niet geladen is. */
    if (window.BFEMarketThreshold) {
      shippingThresholdCents = window.BFEMarketThreshold.thresholdCents(shippingLimit, shippingIsLocal, 'shipping');
      giftThresholdCents = window.BFEMarketThreshold.thresholdCents(giftLimit, giftIsLocal, 'gift');
    } else {
      shippingThresholdCents = shippingLimit * 100 * shippingRate;
      giftThresholdCents = giftLimit * 100 * giftRate;
    }

    texts = {
      shippingRemaining: container.getAttribute('data-text-shipping-remaining') || '',
      giftRemaining: container.getAttribute('data-text-gift-remaining') || '',
      shippingUnlocked: container.getAttribute('data-text-shipping-unlocked') || '',
      allRewardsUnlocked: container.getAttribute('data-text-all-rewards-unlocked') || '',
      activeBadge: container.getAttribute('data-text-active-badge') || 'Active',
      inactiveBadge: container.getAttribute('data-text-inactive-badge') || 'Inactive',
      giftSelect: container.getAttribute('data-text-gift-select') || 'Select',
      giftChoose: container.getAttribute('data-text-gift-choose') || 'Choose your free gift',
      giftSelected: container.getAttribute('data-text-gift-selected') || 'Selected',
      giftSoldOut: container.getAttribute('data-text-gift-sold-out') || 'Sold out'
    };

    textEl = container.querySelector('[data-rewards-text]');
    fillEl = container.querySelector('[data-rewards-fill]');
    milestoneShipping = container.querySelector('[data-milestone-shipping]');
    milestoneGift = container.querySelector('[data-milestone-gift]');
    rewardShipping = container.querySelector('[data-reward-shipping]');
    rewardGift = container.querySelector('[data-reward-gift]');
    shippingLimitDisplay = container.querySelector('[data-shipping-limit-display]');
    giftLimitDisplay = container.querySelector('[data-gift-limit-display]');
    giftGrid = container.querySelector('[data-gift-grid]');
    giftTrigger = container.querySelector('[data-gift-accordion-trigger]');
    giftBody = container.querySelector('[data-gift-accordion-body]');

    /* Lees accordion state uit DOM (server-side gerenderd via Liquid) */
    accordionOpen = giftBody ? giftBody.classList.contains('is-open') : false;

    return true;
  }

  /* Geen initAccordion nodig — click wordt via document delegation afgehandeld */

  function toggleAccordion() {
    if (!giftBody) return;
    accordionOpen = !accordionOpen;

    if (accordionOpen) {
      giftBody.classList.add('is-open');
      if (giftTrigger) giftTrigger.setAttribute('aria-expanded', 'true');
    } else {
      giftBody.classList.remove('is-open');
      if (giftTrigger) giftTrigger.setAttribute('aria-expanded', 'false');
    }
  }

  function openAccordion() {
    if (accordionOpen || !giftBody) return;
    accordionOpen = true;
    giftBody.classList.add('is-open');
    if (giftTrigger) giftTrigger.setAttribute('aria-expanded', 'true');
  }

  function closeAccordion() {
    if (!accordionOpen || !giftBody) return;
    accordionOpen = false;
    giftBody.classList.remove('is-open');
    if (giftTrigger) giftTrigger.setAttribute('aria-expanded', 'false');
  }

  /**
   * Bereken twee cart totalen (in centen):
   * - shippingTotal: voor gratis verzending (B2B telt WEL mee)
   * - giftTotal: voor gratis cadeau (B2B telt NIET mee)
   * Beide sluiten gift items en gift cards uit.
   */
  function getCartTotals(cart) {
    var shippingTotal = cart.total_price || 0;
    var giftTotal = cart.total_price || 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if ((item.properties && item.properties._gift === 'true') || item.final_line_price === 0) {
        shippingTotal -= item.final_line_price;
        giftTotal -= item.final_line_price;
      } else if (item.gift_card) {
        shippingTotal -= item.final_line_price;
        giftTotal -= item.final_line_price;
      } else if (excludedProductType && item.product_type === excludedProductType) {
        /* B2B: alleen uitsluiten van gift, WEL meetellen voor shipping */
        giftTotal -= item.final_line_price;
      }
    }
    if (shippingTotal < 0) shippingTotal = 0;
    if (giftTotal < 0) giftTotal = 0;
    return { shipping: shippingTotal, gift: giftTotal };
  }

  /**
   * Detecteer bestaand gift variant ID in cart
   */
  function getExistingGiftVariantId(cart) {
    var knownGiftVariantIds = [];
    if (giftGrid) {
      var cards = giftGrid.querySelectorAll('[data-gift-card]');
      cards.forEach(function (card) {
        knownGiftVariantIds.push(Number(card.getAttribute('data-variant-id')));
      });
    }
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.final_price === 0 && knownGiftVariantIds.indexOf(item.variant_id) !== -1) {
        return item.variant_id;
      }
    }
    return null;
  }

  /**
   * Format bedrag in centen naar leesbaar geld in de ACTIEVE markt-currency.
   * NB: bewust geen window.themeCurrency.formatMoney — die gebruikt window.theme.moneyFormat
   * (de store's primary EUR-format), waardoor non-EUR markten altijd "€" zien.
   * Intl.NumberFormat respecteert wel de actieve currency + locale per markt.
   */
  function formatMoney(cents, withDecimals) {
    if (window.BFEMarketThreshold) {
      return window.BFEMarketThreshold.formatMoney(cents, withDecimals !== false);
    }

    var currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var locale = (document.documentElement.lang || 'en').replace('_', '-');
    var digits = withDecimals === false ? 0 : 2;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(digits) + ' ' + currencyCode;
    }
  }

  /**
   * Update threshold-labels in de reward rijen met geconverteerde currency.
   * Liquid rendert de raw EUR-waarde formatted met active currency symbol
   * (bijv. "$75.00" voor een €75 setting op US markt) — die is misleidend.
   * Hier overschrijven we met de geconverteerde + afgeronde waarde. Zonder decimalen,
   * want de drempel is al een net bedrag — en zo staat hij gelijk aan banner/USP-blok.
   */
  function updateLimitLabels() {
    if (shippingLimitDisplay) {
      shippingLimitDisplay.textContent = formatMoney(shippingThresholdCents, false);
    }
    if (giftLimitDisplay) {
      giftLimitDisplay.textContent = formatMoney(giftThresholdCents, false);
    }
  }

  /**
   * Update progress bar fill
   * Gebaseerd op gift totaal, maar minimaal tot shipping milestone als shipping bereikt is
   */
  function updateProgressBar(totals) {
    if (!fillEl) return;
    var barMaxCents = giftEnabled ? giftThresholdCents : shippingThresholdCents;
    var shippingThreshold = shippingThresholdCents;

    /* Basis: gift totaal bepaalt de fill (dat is de einddoelstelling) */
    var percent = (totals.gift / barMaxCents) * 100;

    /* Maar als shipping bereikt is, vul minimaal tot shipping milestone positie */
    if (giftEnabled && totals.shipping >= shippingThreshold) {
      var shippingPercent = (shippingThreshold / barMaxCents) * 100;
      if (percent < shippingPercent) percent = shippingPercent;
    }

    if (percent > 100) percent = 100;
    if (percent < 0) percent = 0;
    fillEl.style.width = percent + '%';
  }

  /**
   * Update milestone iconen — elk met eigen totaal
   */
  function updateMilestones(totals) {
    var shippingThreshold = shippingThresholdCents;
    var giftThreshold = giftThresholdCents;

    if (milestoneShipping) {
      milestoneShipping.classList.toggle('is-reached', totals.shipping >= shippingThreshold);
    }

    if (milestoneGift && giftEnabled) {
      milestoneGift.classList.toggle('is-reached', totals.gift >= giftThreshold);
    }
  }

  /**
   * Update tekst boven de bar — elk bedrag met eigen totaal
   */
  function updateMessage(totals) {
    if (!textEl) return;
    var shippingThreshold = shippingThresholdCents;
    var giftThreshold = giftThresholdCents;
    var shippingReached = totals.shipping >= shippingThreshold;
    var giftReached = giftEnabled && totals.gift >= giftThreshold;

    var message = '';
    if (giftEnabled && giftReached) {
      message = texts.allRewardsUnlocked;
    } else if (shippingReached && giftEnabled) {
      var remaining = formatMoney(giftThreshold - totals.gift);
      message = texts.giftRemaining.replace('||amount||', '<span class="strong">' + remaining + '</span>');
    } else if (shippingReached) {
      message = texts.shippingUnlocked;
    } else {
      var remaining = formatMoney(shippingThreshold - totals.shipping);
      message = texts.shippingRemaining.replace('||amount||', '<span class="strong">' + remaining + '</span>');
    }

    textEl.innerHTML = message;
  }

  /**
   * Update reward rijen (active/locked states + badges)
   */
  function updateRewardRows(totals, existingGiftVariantId) {
    var shippingThreshold = shippingThresholdCents;
    var giftThreshold = giftThresholdCents;
    var shippingReached = totals.shipping >= shippingThreshold;
    var giftReached = giftEnabled && totals.gift >= giftThreshold;

    // Container classes
    container.classList.toggle('is-shipping-reached', shippingReached);
    container.classList.toggle('is-gift-reached', giftReached);

    // Shipping rij + badge
    if (rewardShipping) {
      rewardShipping.classList.toggle('is-active', shippingReached);
      var shippingBadgeContainer = rewardShipping.querySelector('.cart-rewards-bfe__reward-badge');
      if (shippingBadgeContainer) {
        if (shippingReached) {
          shippingBadgeContainer.innerHTML = '<span class="cart-rewards-bfe__badge cart-rewards-bfe__badge--active">' +
            texts.activeBadge + '</span>';
        } else {
          shippingBadgeContainer.innerHTML = '';
        }
      }
    }

    // Gift rij + badge
    if (rewardGift && giftEnabled) {
      rewardGift.classList.toggle('is-active', giftReached);
      rewardGift.classList.toggle('is-locked', !giftReached);

      // Badge update
      var giftBadgeContainer = rewardGift.querySelector('.cart-rewards-bfe__reward-badge');
      if (giftBadgeContainer) {
        if (giftReached) {
          if (existingGiftVariantId) {
            giftBadgeContainer.innerHTML = '<span class="cart-rewards-bfe__gift-selected-text">' +
              texts.giftSelected + '</span>';
          } else {
            giftBadgeContainer.innerHTML = '<span class="cart-rewards-bfe__badge cart-rewards-bfe__badge--active">' +
              texts.giftChoose + '</span>';
          }
        } else {
          giftBadgeContainer.innerHTML = '';
        }
      }

      // Update gift card selected states
      if (giftGrid) {
        var cards = giftGrid.querySelectorAll('[data-gift-card]');
        cards.forEach(function (card) {
          var cardVariantId = Number(card.getAttribute('data-variant-id'));
          var isSelected = existingGiftVariantId && cardVariantId === existingGiftVariantId;
          card.classList.toggle('is-selected', isSelected);

          var actionEl = card.querySelector('.cart-rewards-bfe__gift-action');
          var isSoldOut = card.hasAttribute('data-sold-out');
          if (actionEl) {
            if (isSelected) {
              actionEl.innerHTML = '<span class="cart-rewards-bfe__gift-selected-text">' +
                texts.giftSelected + '</span>';
            } else if (isSoldOut) {
              actionEl.innerHTML = '<span class="cart-rewards-bfe__gift-sold-out">' +
                texts.giftSoldOut + '</span>';
            } else {
              actionEl.innerHTML = '<button class="cart-rewards-bfe__gift-select-btn" data-gift-select="' +
                cardVariantId + '" type="button"' + (giftReached ? '' : ' disabled') + '>' +
                (giftReached ? texts.giftSelect : texts.inactiveBadge) + '</button>';
            }
          }
        });
      }

      /* Auto-open accordion wanneer gift drempel bereikt is en er nog geen gift gekozen is */
      if (giftReached && !existingGiftVariantId && !accordionOpen) {
        openAccordion();
      }
      /* Sluit accordion als drempel niet meer bereikt */
      if (!giftReached && accordionOpen) {
        closeAccordion();
      }
    }
  }

  /**
   * Verwijder bestaand gift item uit cart (alleen items met _gift property)
   */
  function removeExistingGift(cart) {
    var giftKey = null;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.properties && item.properties._gift === 'true') {
        giftKey = item.key;
        break;
      }
    }

    if (!giftKey) return Promise.resolve();

    return fetch(window.theme.routes.cart + '/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftKey, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  /**
   * Voeg gift item toe aan cart
   */
  function addGiftToCart(variantId) {
    return fetch(window.theme.routes.cart + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { _gift: 'true' }
        }]
      })
    }).then(function (r) { return r.json(); });
  }

  /**
   * Handle gift selectie
   */
  function handleGiftSelect(variantId) {
    if (isProcessing) return;
    isProcessing = true;

    // Disable alle select buttons
    if (container) {
      var buttons = container.querySelectorAll('[data-gift-select]');
      buttons.forEach(function (btn) { btn.disabled = true; });
    }

    fetch(window.theme.routes.cart + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return removeExistingGift(cart);
      })
      .then(function () {
        return addGiftToCart(variantId);
      })
      .then(function () {
        return fetch(window.theme.routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (updatedCart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: updatedCart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('Cart rewards: gift select error', err);
      })
      .finally(function () {
        isProcessing = false;
      });
  }

  /**
   * Check of gift verwijderd moet worden (cart onder drempel)
   */
  function checkGiftEligibility(cart) {
    if (isProcessing) return;

    if (!giftEnabled) return;

    var totals = getCartTotals(cart);
    var giftCents = giftThresholdCents;
    var totalCents = totals.gift;

    if (totalCents < giftCents) {
      var hasGift = false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].properties && cart.items[i].properties._gift === 'true') {
          hasGift = true;
          break;
        }
      }

      if (hasGift) {
        isProcessing = true;
        closeAccordion();
        removeExistingGift(cart)
          .then(function () {
            return fetch(window.theme.routes.cart + '.js').then(function (r) { return r.json(); });
          })
          .then(function (updatedCart) {
            document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: updatedCart }, bubbles: true }));
            document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          })
          .catch(function (err) {
            console.error('Cart rewards: auto-remove gift error', err);
          })
          .finally(function () {
            isProcessing = false;
          });
      }
    }
  }

  /**
   * Main cart change handler
   * Her-initialiseert DOM referenties bij elke update (robuust tegen cart drawer re-renders)
   */
  function onCartChange(event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;

    /* Her-query DOM elementen (kunnen vervangen zijn door cart reload) */
    if (!initElements()) return;

    var totals = getCartTotals(cart);
    var existingGiftVariantId = getExistingGiftVariantId(cart);

    updateProgressBar(totals);
    updateMilestones(totals);
    updateMessage(totals);
    updateRewardRows(totals, existingGiftVariantId);
    updateLimitLabels();
    checkGiftEligibility(cart);
  }

  // Initialisatie
  initElements();
  updateLimitLabels();

  // Alle click handlers via document delegation (robuust na DOM re-renders door cart reload)
  document.addEventListener('click', function (e) {
    // Accordion trigger toggle
    var trigger = e.target.closest('[data-gift-accordion-trigger]');
    if (trigger) {
      e.preventDefault();
      // Her-query elementen (DOM kan vervangen zijn)
      giftTrigger = trigger;
      giftBody = document.querySelector('[data-gift-accordion-body]');
      if (giftBody) {
        accordionOpen = giftBody.classList.contains('is-open');
        toggleAccordion();
      }
      return;
    }

    // Gift product selectie
    var btn = e.target.closest('[data-gift-select]');
    if (btn) {
      e.preventDefault();
      var variantId = Number(btn.getAttribute('data-gift-select'));
      if (variantId) {
        handleGiftSelect(variantId);
      }
    }
  });

  document.addEventListener('theme:cart:change', onCartChange);

  /* Drempel gewijzigd door een Intelligems shipping-test (market-threshold-bfe.js).
     De balk is server-side gerenderd met de metaobject-drempel, dus opnieuw rekenen. */
  function refreshForThreshold() {
    fetch(window.theme.routes.cart + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { onCartChange({ detail: { cart: cart } }); })
      .catch(function (err) { console.error('Cart rewards: threshold refresh error', err); });
  }
  document.addEventListener('bfe:market-threshold:change', refreshForThreshold);
  /* Was Intelligems al klaar vóór dit script laadde, dan is het event al geweest */
  if (window.BFEMarketThreshold && window.BFEMarketThreshold.igShippingThreshold &&
      window.BFEMarketThreshold.igShippingThreshold()) {
    refreshForThreshold();
  }
})();
